<template>
	<div>
		<tile-event :event="event" :group-events="groupEvents" @changed="$emit('changed')"></tile-event>
    	<div v-if="linkedEvents.length > 0" style="text-align: right; cursor: pointer; user-select: none;" @click="show_linked_events = !show_linked_events" class="ks-font-size-s mb-0">
        	<template v-if="show_linked_events">Hide</template>
        	<template v-else>Show</template>
        	<template v-if="linkedEvents.length > 1">&nbsp;{{linkedEvents.length}} linked events</template>
        	<template v-else>&nbsp;linked event</template>
        	&nbsp;
        	<k-icon small>link</k-icon>
    	</div>
		<div v-for="linked_event in linkedEvents" :key="linked_event.uuid" v-if="show_linked_events">
			<tile-event linked :event="linked_event" :group-events="groupEvents" @changed="$emit('changed')" class="mb-1"></tile-event>
		</div>
	</div>
</template>
<script>
import TileEvent from './TileEvent.vue';
export default {
	props: {
		"event": Object, 
		"group-events": {
			type: Array,
			default: () => []
		},
		"linked-events": {
			type: Array,
			default: []
		}
	},
	data () {
		return {
			show_linked_events: true
		}
	},
	components: {
		TileEvent
	},
}
</script>